export const SCOOTER_LOADING = "scooter/loading";
export const SCOOTER_ERROR = "scooter/error";
export const SCOOTER_FILTERS = "scooter/filters";
export const SCOOTER_LIST = "scooter/list";
export const SCOOTER_CREATE = "scooter/create";
export const SCOOTER_UPDATE = "scooter/update";
export const SCOOTER_DELETE = "scooter/delete";

export const SCOOTER_ACTION_LOCK = "scooter/action/lock";
export const SCOOTER_ACTION_UNLOCK = "scooter/action/unlock";
export const SCOOTER_ACTION_VOICE = "scooter/action/voice";
export const SCOOTER_ACTION_OPEN_COVER = "scooter/action/open_cover";
export const SCOOTER_ACTION_UPDATE_STATUS = "scooter/action/update_status";



// WEBPACK FOOTER //
// ./src/actions/scooter/scooter/constants.js